import VideoEmbedSelect from './VideoEmbedSelect';
import './video-embed-select.scss'

export default VideoEmbedSelect;